// extracted by mini-css-extract-plugin
module.exports = {"mpu":"mpu_vtw7K","billboard":"billboard_2Y_0e"};